import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, inputClasses, inputLabelClasses } from '@mui/material';
import { Col, Row } from 'react-bootstrap';
import Home from '../home/Home';
import FundRqst_service from '../../Services/FundRqst_service';
import Snackbar from '../Snacbar'
import { getUserId } from '../Utils/Common';
import FileSaver from 'file-saver';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";
import { ToggleButton } from '@mui/material';

const CssTextField = styled(TextField)(`
  .${inputClasses.root} {
    height:35px;
  }
  .${inputLabelClasses.root} {
    font-family: Times New Roman;
    font-weight:bold;
    &.${inputLabelClasses.focused} {
      color: primary;
    }
  }
`);
const Csscontrol = styled(FormControl)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
        }
    },
});
const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));
const Item1 = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));
const Item2 = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'right',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: 'black',
        backgroundColor: 'rgb(61, 195, 177)',
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: 'Times New Roman',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: 'white',
    },
}));


function FundAllocation() {
    const [message, setMessage] = useState('');
    const [open, setOpen] = useState(false);
    const [severit, setseverit] = useState('');
    const [status, setstatus] = useState('')
    const [fundstatusdrp, setfundstatusdrp] = useState([]);
    const [Vendordrp, setVendordrp] = useState([]);
    const [PaymentModedrp, setPaymentModedrp] = useState([]);
    const [fundallocationvalues, setfundallocationvalues] = useState({
        cmid: '',
        purpose_pmtid: '',
        purpose_reqpurid: '',
        purposeSummary_id: '',

        Reqamt: '',
        Aprvlamt: '',
        FirstLvlamt: '',
        secLvlamt: '',

        fundstatus: '',
        jobNo: '',
        vendorType: '',
        allocatedAmt: '',
        paymentMode: '',
        allocatedRmks: '',
    });

    const AllocationFundStatusHandleChange = (e) => {
        if (e.target.value === 'JOB') {
            setstatus(1)
        } else if (e.target.value === 'VENDOR') {
            setstatus(2)
        } else if (e.target.value === 'MISCELLANEOUS') {
            setstatus(3)
        } else if (e.target.value === 'CLIENT') {
            setstatus(4)
        }
        setfundallocationvalues({
            ...fundallocationvalues, fundstatus: e.target.value, cmid: '', purpose_pmtid: '', purpose_reqpurid: '', purposeSummary_id: '',
            Reqamt: '', Aprvlamt: '', FirstLvlamt: '', secLvlamt: '', allocatedAmt: '', paymentMode: '', allocatedRmks: '', jobNo: '', vendorType: '',
        })
        setFilteredDetails([])
        setFilteredDetails2([])
        setAllocationDetails([])
        setAllocationDetails2([])
        setAllocationDetails3([])
        setAllocationDetails4([])
        setAllocationDetails5([])
        var consignmentNumber = '';
        if (e.target.value === 'JOB') {
            if (fundallocationvalues.jobNo === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = fundallocationvalues.jobNo;
            }
        }
        else if (e.target.value !== 'JOB') {
            if (fundallocationvalues.vendorType === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = fundallocationvalues.vendorType;
            }
        }
        let details = { consignmentNumber: consignmentNumber, status: '5', requestStatus: e.target.value }
        FundRqst_service.getPaymentNonJobNo(details).then(res => { setAllocationDetails(res.data); setFilteredDetails(res.data) });

        let details2 = { consignmentNumber: consignmentNumber, status: '5', requestStatus: e.target.value }
        FundRqst_service.getPaymentJobNo(details2).then(res => { setAllocationDetails4(res.data); setFilteredDetails2(res.data) });

        FundRqst_service.getBillPaymentType().then(res => { setPaymentModedrp(res.data); });
        if (e.target.value === 'JOB') {
            SetVendorHidden(true)
            SetJobHidden(false)
            setdesignHidden(false)
            settablehidden(false)
            setsearchbtnhidden(false)
        }
        else if (e.target.value === 'VENDOR' || e.target.value === 'MISCELLANEOUS' || e.target.value === 'CLIENT') {
            FundRqst_service.getVendorType(e.target.value).then(res => {
                setVendordrp(res.data)
            });
            SetVendorHidden(false)
            SetJobHidden(true)
            setdesignHidden(false)
            settablehidden(false)
            setsearchbtnhidden(true)
        }
        else if (e.target.value === "") {
            SetVendorHidden(true)
            SetJobHidden(false)
            setdesignHidden(true)
            settablehidden(true)
            setsearchbtnhidden(false)
        }
    }
    const fundAlc_jobNoHandleChange = (e) => {
        setfundallocationvalues({ ...fundallocationvalues, jobNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const fundAlc_vendortypHandleChange = (e) => {
        setfundallocationvalues({ ...fundallocationvalues, vendorType: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const fundAlc_AlocatedamtHandleChange = (e) => {
        setfundallocationvalues({ ...fundallocationvalues, allocatedAmt: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const fundAlc_AlocatedpaymntmdHandleChange = (e) => {
        setfundallocationvalues({ ...fundallocationvalues, paymentMode: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const fundAlc_AlctdRmksHandleChange = (e) => {
        setfundallocationvalues({ ...fundallocationvalues, allocatedRmks: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FundStsName = () => {
        if (status === 1) {
            return 'Job No';
        }
        else if (status === 2) {
            return 'VENDOR';
        }
        else if (status === 3) {
            return 'MISCELLANEOUS';
        }
        else if (status === 4) {
            return 'CLIENT';
        }
    }
    //keydown
    const jobkeydown = (e) => {
        if (e.key === 'Enter') {
            allocationSearch()
        }
    }
    const Allocatedkeydown = (e) => {
        if (e.key === 'Enter') {
            document.getElementById('paymentmode').focus()
        }
    }
    const paymentmodekeydown = (e) => {
        if (e.key === 'Enter') {
            document.getElementById('rmks').focus()
        }
    }
    ///hidden
    const [designHidden, setdesignHidden] = useState(true);
    const [tablehidden, settablehidden] = useState(true);
    const [VendorHidden, SetVendorHidden] = useState(true);
    const [JobHidden, SetJobHidden] = useState(false);
    const [searchbtnhidden, setsearchbtnhidden] = useState(true);

    const [AllocationDetails, setAllocationDetails] = useState([]);
    const [AllocationDetails2, setAllocationDetails2] = useState([]);
    const [AllocationDetails3, setAllocationDetails3] = useState([]);
    const [AllocationDetails4, setAllocationDetails4] = useState([]);
    const [AllocationDetails5, setAllocationDetails5] = useState([]);
    // const [paymentcopydetails, setpaymentcopydetails] = useState([]);
    //
    const [FilteredDetails, setFilteredDetails] = useState([])
    const [FilteredDetails2, setFilteredDetails2] = useState([])

    const [verifyDis, setverifyDis] = useState(true);
    const [updateDis, setupdateDis] = useState(true);
    const [NonverifyDis, setNonverifyDis] = useState(true);
    const [DownldRqstDis, setDownldRqstDis] = useState(true);
    //processing
    const [verifyProcs, setverifyProcs] = useState(false)
    const [updateProcs, setupdateProcs] = useState(false)
    const [nonverifyProcs, setnonverifyProcs] = useState(false)
    const [dwnldRqstCopyProcs, setdwnldRqstCopyProcs] = useState(false)
    const [refreshProcs, setrefreshProcs] = useState(false)
    ///resetoperation=============>
    const resetalloperation = () => {
        setfundallocationvalues({
            ...fundallocationvalues, cmid: '', purpose_pmtid: '', purpose_reqpurid: '', purposeSummary_id: '',
            Reqamt: '', Aprvlamt: '', FirstLvlamt: '', secLvlamt: '', allocatedAmt: '', paymentMode: '', allocatedRmks: '', jobNo: ''
        })
        setAllocationDetails([])
        setAllocationDetails2([])
        setAllocationDetails3([])
        setAllocationDetails4([])
        setAllocationDetails5([])
        setverifyProcs(false)
        setupdateProcs(false)
        setnonverifyProcs(false)
        setdwnldRqstCopyProcs(false)
        setrefreshProcs(false)
        setverifyDis(true)
        setupdateDis(true)
        setNonverifyDis(true)
        setDownldRqstDis(true)
    }
    ////validation================>
    const AllocationValidation = () => {
        if (fundallocationvalues.allocatedAmt !== '') {
            if (fundallocationvalues.paymentMode !== '') {
                return true;
            } else {
                setMessage('Please Select Payment Mode');
                setseverit('warning');
                setOpen(true);
                document.getElementById('paymentmode').focus();
            }
        } else {
            setMessage('Please Enter Payment Request Amount');
            setseverit('warning');
            setOpen(true);
            document.getElementById('alocAmt').focus();
        }
        return false;
    }
    ////jobSearch=================>
    const allocationSearch = () => {
        setverifyDis(true);
        setupdateDis(true);
        setNonverifyDis(true);
        setDownldRqstDis(true);
        setfundallocationvalues({
            ...fundallocationvalues, Reqamt: '', Aprvlamt: '', FirstLvlamt: '', secLvlAmt: '', allocatedAmt: '',
            paymentMode: '', secLevlRmks: '', cmid: '', purpose_pmtid: '', purpose_reqpurid: '',
        })
        setAllocationDetails2([]);
        setAllocationDetails3([]);
        Getpaymentjob_nonjob_no();
    }
    /////
    const [selected, setSelected] = useState([]);
    const [selected1, setSelected1] = useState([]);
    ///ontableclickprocess========>
    const getnonpurpose = (trns) => {
        const selectedIndex = selected.indexOf(trns.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, trns.consignmentNumber);
        }
        setSelected(newSelected);
        setAllocationDetails2([])
        setAllocationDetails5([])
        setverifyDis(true)
        setupdateDis(true)
        setNonverifyDis(true)
        setDownldRqstDis(true)
        setfundallocationvalues({
            ...fundallocationvalues, cmid: trns.cmId, Reqamt: '', Aprvlamt: '', FirstLvlamt: '', secLvlamt: '', allocatedAmt: '', paymentMode: '',
            allocatedRmks: '', purpose_pmtid: '', purpose_reqpurid: '',
        })
        setAllocationDetails3([]);

        let details = { cmId: trns.cmId, status: '5', requestStatus: fundallocationvalues.fundstatus }
        FundRqst_service.getPaymentReqPurpose(details).then(res => {
            setAllocationDetails2(res.data);
        })
        let details2 = { paymentId: trns.cmId, requestStatus: fundallocationvalues.fundstatus }
        FundRqst_service.getPaymentSummaryDetails(details2).then(res => {
            setAllocationDetails5(res.data);
        })
    }
    const isSelected = (name) => selected.indexOf(name) !== -1;
    ///
    const getpurpose = (trns) => {
        const selectedIndex = selected.indexOf(trns.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, trns.consignmentNumber);
        }
        setSelected(newSelected);

        setAllocationDetails3([])
        setAllocationDetails5([])
        setverifyDis(true)
        setupdateDis(true)
        setNonverifyDis(true)
        setDownldRqstDis(true)
        setAllocationDetails2([]);
        setfundallocationvalues({
            ...fundallocationvalues, cmid: trns.cmId, Reqamt: '', Aprvlamt: '', FirstLvlamt: '', secLvlamt: '', allocatedAmt: '', paymentMode: '',
            allocatedRmks: '', purpose_pmtid: '', purpose_reqpurid: '',
        })

        let details = { cmId: trns.cmId, status: '9', requestStatus: fundallocationvalues.fundstatus }
        FundRqst_service.getPaymentReqPurpose(details).then(res => {
            setAllocationDetails3(res.data);
        })

        let details2 = { paymentId: trns.cmId, requestStatus: fundallocationvalues.fundstatus }
        FundRqst_service.getPaymentSummaryDetails(details2).then(res => {
            setAllocationDetails5(res.data);
        })
    }
    const isReqjobSelected = (name) => selected.indexOf(name) !== -1;
    /////
    const nonverifypurpose = (trns) => {
        const selectedIndex = selected1.indexOf(trns.reqAmount);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected1, trns.reqAmount);
        }
        setSelected1(newSelected);
        setAllocationDetails3([]);
        setverifyDis(false)
        setupdateDis(true)
        setNonverifyDis(true)
        setDownldRqstDis(false)
        getpaymentdetailsAssign(trns.paymentId, trns.reqPurpose, 1)

        // let details = { cmId: fundallocationvalues.cmid, reqPurpose: trns.reqPurpose, status: '1' }
        // FundRqst_service.getPaymentCopy(details).then(res => {
        //     setpaymentcopydetails(res.data);
        // })
    }
    const isNonReqItemSelected = (name) => selected1.indexOf(name) !== -1;
    ///
    const verifypurpose = (trns) => {
        const selectedIndex = selected1.indexOf(trns.reqAmount);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected1, trns.reqAmount);
        }
        setSelected1(newSelected);
        setAllocationDetails2([]);
        setverifyDis(true)
        setupdateDis(false)
        setNonverifyDis(false)
        setDownldRqstDis(false)
        getpaymentdetailsAssign(trns.paymentId, trns.reqPurpose, 2)

        // let details = { cmId: fundallocationvalues.cmid, reqPurpose: trns.reqPurpose, status: '1' }
        // FundRqst_service.getPaymentCopy(details).then(res => {
        //     setpaymentcopydetails(res.data);
        // })
    }
    const isReqItemSelected = (name) => selected1.indexOf(name) !== -1;
    ///getFirtLvlvrfyAssign====>
    const getpaymentdetailsAssign = (payid, reqid, val) => {
        let details = { paymentId: payid }
        FundRqst_service.getPaymentDetails(details).then(res => {
            const data = res.data;
            const details = data.map((trns) => trns);
            var txt_amount, releaseMode, appRemarks = '';
            if (val === 1) {
                txt_amount = details[0].secondLevelAmount
            } else {
                txt_amount = details[0].releaseAmount
            }
            if (details[0].appMode === null || details[0].appMode === '' || !details[0].appMode) {
                releaseMode = '';
            } else {
                releaseMode = details[0].appMode;
            }
            if (details[0].appRemarks === null || details[0].appRemarks === '' || !details[0].appRemarks) {
                appRemarks = '';
            } else {
                appRemarks = details[0].appRemarks;
            }
            setfundallocationvalues({
                ...fundallocationvalues, Reqamt: details[0].reqAmount, Aprvlamt: details[0].approvalAmunt, FirstLvlamt: details[0].firstLevelAmount, secLvlamt: details[0].secondLevelAmount,
                allocatedAmt: txt_amount, allocatedRmks: appRemarks, paymentMode: releaseMode, purpose_pmtid: payid, purpose_reqpurid: reqid
            })
        }).catch(error => {
            setMessage(error.message);
            setseverit('error');
            setOpen(true);
        })
    }
    /////
    const Getpaymentjob_nonjob_no = () => {
        var consignmentNumber = '';
        if (fundallocationvalues.fundstatus === 'JOB') {
            if (fundallocationvalues.jobNo === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = fundallocationvalues.jobNo;
            }
        }
        else if (fundallocationvalues.fundstatus !== 'JOB') {
            if (fundallocationvalues.vendorType === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = fundallocationvalues.vendorType;
            }
        }
        let details = { consignmentNumber: consignmentNumber, status: '5', requestStatus: fundallocationvalues.fundstatus }
        FundRqst_service.getPaymentNonJobNo(details).then(res => { setAllocationDetails(res.data); setFilteredDetails(res.data) });

        let details2 = { consignmentNumber: consignmentNumber, status: '5', requestStatus: fundallocationvalues.fundstatus }
        FundRqst_service.getPaymentJobNo(details2).then(res => { setAllocationDetails4(res.data); setFilteredDetails2(res.data) });

    }
    // buttonsoperations
    const verify_update_operations = () => {
        if (AllocationValidation() === true) {
            let details = {
                cmId: fundallocationvalues.purpose_pmtid, reqAmount: null, reqPurpose: null, reqPaidTo: null, reqDate: null, reqBy: null, approvalAmunt: null,
                approvalDate: null, approvalBy: null, firstLevelAmount: null, firstLevelDate: null, firstVeryBy: null,
                secondLevelAmount: null, secondLevelDate: null, secondVeryBy: null, allocatedAmount: fundallocationvalues.allocatedAmt, allocatedMode: fundallocationvalues.paymentMode,
                allocatedVoucherNo: null, allocatedVoucherType: null, allocatedVocherCopy: null, allocatedPrintedBy: null, allocatedDate: null, allocatedBy: getUserId(),
                status: '5', remarks: fundallocationvalues.allocatedRmks, referenceNo: null, bankName: null, accountNo: null, ifsc: null, benName: null,
                gstinPayee: null, requestStatus: fundallocationvalues.fundstatus, refundStatus: null,
            }
            FundRqst_service.updatePaymentDetails(details).then(res => {
                const message = res.data.message;
                console.log('msg= ' + JSON.stringify(message))
                if (message.toString() === 'SUCCESS') {
                    setMessage('Verified Successfully');
                    setseverit('success');
                    setOpen(true);
                    Getpaymentjob_nonjob_no();
                    resetalloperation();
                } else {
                    setMessage('Verification Failed ' + message.toString())
                    setseverit('error')
                    setOpen(true)
                }
            }).catch(error => {
                setMessage(error.message);
                setseverit('error');
                setOpen(true);
            })
        }
    }
    const verifyBtn = () => {
        setverifyProcs(true)
        verify_update_operations()
        setverifyProcs(false)
    }
    const updateBtn = () => {
        setupdateProcs(true)
        verify_update_operations()
        setupdateProcs(false)
    }
    const NonverifyBtn = () => {
        setnonverifyProcs(true)
        let details = {
            cmId: fundallocationvalues.cmid, paymentId: fundallocationvalues.purpose_pmtid, status: '5',
            createdBy: getUserId(), requestStatus: fundallocationvalues.fundstatus
        }
        FundRqst_service.updatePaymentStatus(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Verified Successfully');
                setseverit('success');
                setOpen(true);
                resetalloperation();
                Getpaymentjob_nonjob_no()
            } else {
                setMessage('Verification Failed ,Warning ..!!' + message.toString());
                setseverit('error');
                setOpen(true);
                document.getElementById('alocAmt').focus();
            }
        }).catch(error => {
            setMessage('Verification Failed ' + error.message);
            setseverit('error');
            setOpen(true);
        })
        setnonverifyProcs(false)
    }
    const saveimage = () => {
        setdwnldRqstCopyProcs(true)
        let details = { cmId: fundallocationvalues.cmid, reqPurpose: fundallocationvalues.purpose_reqpurid, status: '1' }
        FundRqst_service.getPaymentCopy(details).then(res => {
            const data = res.data;
            const detaill = data.map(node => node.docImage)
            // console.log('before saveAs '+JSON.stringify(detaill.toString()))
            // FileSaver.saveAs(`data:image/jpeg;base64,${detaill.toString()}`, fundallocationvalues.cmid + "-" + fundallocationvalues.purpose_reqpurid + ".jpg");
            const filedata = detaill.toString()
            const formates = filedata.split('/9j/4');
            //    console.log('ggg '+JSON.stringify(formates))
            if (formates[0] === '') {
                FileSaver.saveAs(`data:image/jpg;base64,${detaill.toString()}`, fundallocationvalues.cmid + "-" + fundallocationvalues.purpose_reqpurid + ".jpg");
            } else {
                const Pngformates = filedata.split('iVBORw0KGg');
                if (Pngformates[0] === '') {
                    FileSaver.saveAs(`data:image/jpg;base64,${detaill.toString()}`, fundallocationvalues.cmid + "-" + fundallocationvalues.purpose_reqpurid + ".jpg");
                } else {
                    FileSaver.saveAs(`data:application/pdf;base64,${detaill.toString()}`, fundallocationvalues.cmid + "-" + fundallocationvalues.purpose_reqpurid + ".pdf");
                }
            }
            setdwnldRqstCopyProcs(false)
        }).catch(error => {
            setMessage('Insertion Failed! ,' + error.message)
            setseverit('error')
            setOpen(true)
            setdwnldRqstCopyProcs(false)
        })
        // FileSaver.saveAs(lastresult[0].docImage, fundallocationvalues.cmid + "-" + fundallocationvalues.purpose_reqpurid + ".pdf")
        // setdwnldRqstCopyProcs(false)
    }
    const RefreshBtn = () => {
        setrefreshProcs(true)
        setFilteredDetails([])
        setFilteredDetails2([])
        setAllocationDetails([])
        setAllocationDetails2([])
        setAllocationDetails3([])
        setAllocationDetails4([])
        setfundallocationvalues({
            ...fundallocationvalues, cmid: '', purpose_pmtid: '', purpose_reqpurid: '', fundstatus: 'JOB',
            Reqamt: '', Aprvlamt: '', FirstLvlamt: '', secLvlamt: '', paymentMode: '', allocatedRmks: '', allocatedAmt: '',
        })
        document.getElementById('fundstatus').focus();
        Getpaymentjob_nonjob_no()
        setverifyDis(true)
        setupdateDis(true)
        setNonverifyDis(true)
        setDownldRqstDis(true)
        setrefreshProcs(false)
    }
    //table search
    const fundSrch = () => {
        return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
            onChange={(e) => { fundOnchange(e.target.value) }} />
    }
    const fundOnchange = (searchedVal) => {
        const filteredvalue = AllocationDetails.filter((trns) => {
            return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (filteredvalue.length > 1) {
            setFilteredDetails(AllocationDetails)
        } else {
            setFilteredDetails(filteredvalue)
        }
    }
    const fundSrch2 = () => {
        return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
            onChange={(e) => { fund2Onchange(e.target.value) }} />
    }
    const fund2Onchange = (searchedVal) => {
        const filteredvalue = AllocationDetails4.filter((trns) => {
            return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (filteredvalue.length > 1) {
            setFilteredDetails2(AllocationDetails4)
        } else {
            setFilteredDetails2(filteredvalue)
        }
    }
    ////getfundstatues=======>
    const FundStatusDropdown = async () => {
        FundRqst_service.getFundStatus().then(res => {
            setfundstatusdrp(res.data)
        })
    }
    useEffect(() => {
        FundStatusDropdown();
    }, []);

    const handleClose = () => {
        setOpen(false)
    }

    const navigate = useNavigate();
    const BackBotton = () => {
        navigate('/fund2ndlvlvrfy');
    }
    const ForwordBotton = () => {
        navigate('/fundrels');
    }
    return (
        <div >
            <Home />
            <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
            <div style={{ paddingLeft: '80px', transition: '1s', transitionDelay: 'revert-layer' }}>
            <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
                <Grid2 container>
                    <Box style={{ width: '11.5%' }}>
                        <Item1>
                            {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small" >
                                <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px', marginLeft: '5px' }} /> </ToggleButton> */}
                            <lable style={{ fontFamily: 'Times New Roman', fontWeight: 'bold', fontSize: '10px', color: 'red', marginLeft: '2px' }}>Non Allocated Job</lable>
                            <TableContainer sx={{ maxHeight: 300 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell className='tblrowcss' style={{ textAlign: 'center' }}>`{FundStsName()}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow >
                                            <StyledTableCell className='tblrowcss' style={{ textAlign: 'center' }}>{fundSrch()}</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {FilteredDetails.map((trns) => {
                                            const isItemSelected = isSelected(trns.consignmentNumber);
                                            return (
                                                <TableRow hover selected={isItemSelected} key={trns.consignmentNumber} onClick={() => getnonpurpose(trns)}>
                                                    <StyledTableCell className='tblcellcss' style={{ color: 'darkblue', textAlign: 'center' }}>{trns.consignmentNumber}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item1>
                    </Box>
                    <Box style={{ width: '20%' }}>
                        <Item>
                            <lable style={{ fontSize: '10px', fontWeight: 'bold', color: 'red' }}>Non Allocated Purpose</lable>
                            <TableContainer sx={{ maxHeight: 300 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered' >
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell className='tblrowcss' style={{ width: '10px', textAlign: 'center' }}>Sl</StyledTableCell>
                                            <StyledTableCell className='tblrowcss' style={{ width: '100px', textAlign: 'center' }}>Description</StyledTableCell>
                                            <StyledTableCell className='tblrowcss' style={{ width: '40px', textAlign: 'center' }}>Amount</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {AllocationDetails2.map((trns) => {
                                            const isItemSelected = isNonReqItemSelected(trns.reqAmount);
                                            return (
                                                <TableRow selected={isItemSelected} key={trns.reqAmount} onClick={() => nonverifypurpose(trns)}>
                                                    <StyledTableCell className='tblcellcss' style={{ color: 'darkblue', textAlign: 'center' }}>{trns.serialNumber}</StyledTableCell>
                                                    <StyledTableCell className='tblcellcss' style={{ color: 'darkblue', textAlign: 'center' }}>{trns.reqPurpose}</StyledTableCell>
                                                    <StyledTableCell className='tblcellcss' style={{ color: 'darkblue', textAlign: 'center' }}>{trns.reqAmount}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Box>
                    <Box style={{ width: '37%' }}>
                        <Item>
                            <div style={{ color: 'red', fontWeight: 'bold', fontFamily: 'Times New Roman', fontSize: '20px', marginTop: '2%', marginBottom: '2%', }}><center>FUND ALLOCATION</center></div>
                            <Csscontrol fullWidth size='small' style={{ width: '35%', }}>
                                <InputLabel id="demo-select-small" style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }}>Fund Status</InputLabel>
                                <Select label="Fund Statusssssss" style={{ fontSize: '13px', fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', }} onChange={AllocationFundStatusHandleChange} value={fundallocationvalues.fundstatus}>
                                    <MenuItem></MenuItem>
                                    {fundstatusdrp.map(status => (
                                        <MenuItem value={status.requestStatus}>{status.requestStatus}</MenuItem>
                                    ))}
                                </Select>
                            </Csscontrol>

                            <CssTextField hidden={JobHidden} sx={{ input: { fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', fontSize: '13px', textAlign: 'center' } }} size='small' id='fundstatus'
                                style={{ width: '35%', marginLeft: '2%', marginRight: '1%' }} label="Job No" variant="outlined"
                                value={fundallocationvalues.jobNo} onChange={fundAlc_jobNoHandleChange} onKeyDown={jobkeydown} />

                            <Button style={{ fontFamily: 'Times New Roman' }} size='small' hidden={searchbtnhidden} variant="contained" color="primary" onClick={allocationSearch}>Search</Button>

                            <Csscontrol hidden={VendorHidden} fullWidth size='small' style={{ width: '35%', marginLeft: '2%' }}>
                                <InputLabel id="demo-select-small" style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }}>Vendor Type</InputLabel>
                                <Select label="Vendor Typeeee" InputLabelProps={{ shrink: true, }} native style={{ textAlign: 'center', fontSize: '13px', fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', }} onChange={fundAlc_vendortypHandleChange} value={fundallocationvalues.vendorType}>
                                    <option></option>
                                    {Vendordrp.map(trns => (
                                        <option value={trns.reqPaidTo}>{trns.reqPaidTo}</option>
                                    ))}
                                </Select>
                            </Csscontrol>

                            <div hidden={designHidden}>
                                <Row className='mt-3'>
                                    <Col xs={4}>
                                        <InputLabel style={{ fontFamily: 'Times New Roman',color:'black', fontSize: '12px', fontWeight: 'bold' }}>Request Amt :</InputLabel>
                                    </Col>
                                    <Col xs={2} style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{fundallocationvalues.Reqamt}</Col>
                                    <Col xs={4}>
                                        <InputLabel style={{ color:'black',fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold' }}>Approval Amt :</InputLabel>
                                    </Col>
                                    <Col xs={2} style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{fundallocationvalues.Aprvlamt}</Col>
                                </Row>
                                <Row className='mt-2'>
                                    <Col xs={4}>
                                        <InputLabel style={{ color:'black',fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold' }}>1stLvlVerifAmt :</InputLabel>
                                    </Col>
                                    <Col xs={2} style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{fundallocationvalues.FirstLvlamt}</Col>
                                    <Col xs={4}>
                                        <InputLabel style={{ color:'black',fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold' }}>2ndLvlVerifAmt :</InputLabel>
                                    </Col>
                                    <Col xs={2} style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{fundallocationvalues.secLvlamt}</Col>
                                </Row>
                                <Row className='mt-4 mb-2'>
                                    <Col>
                                        <CssTextField size='small' sx={{ input: { color: 'black', textAlign: 'center', fontSize: '13px', fontWeight: 'bold' } }} label="Allocated Amount" id='alocAmt' variant="outlined" style={{ width: '49%', fontSize: '13px' }} required
                                            value={fundallocationvalues.allocatedAmt} onChange={fundAlc_AlocatedamtHandleChange} onKeyDown={Allocatedkeydown} />

                                        <Csscontrol fullWidth size='small' style={{ width: '49%', marginLeft: '1%', marginBottom: '0.5%' }} onKeyDown={paymentmodekeydown} required>
                                            <InputLabel id="demo-select-small" style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }}>Allocated Payment Mode</InputLabel>
                                            <Select label="Allocated Payment Modeeeee" style={{ fontSize: '13px', textAlign: 'center', fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', }} id='paymentmode' InputLabelProps={{ shrink: true, }} native onChange={fundAlc_AlocatedpaymntmdHandleChange} value={fundallocationvalues.paymentMode}>
                                                <option></option>
                                                {PaymentModedrp.map(trns => (
                                                    <option value={trns.paymentType}>{trns.paymentType}</option>
                                                ))}
                                            </Select>
                                        </Csscontrol>
                                    </Col>
                                </Row>
                                <CssTextField size='small' sx={{ input: { fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', fontSize: '13px' } }} id='rmks' label="Allocated Remarks" variant="outlined"
                                  style={{marginTop:'3%',width:'220px'}}  value={fundallocationvalues.allocatedRmks} onChange={fundAlc_AlctdRmksHandleChange} />
                            </div>
                        </Item>
                    </Box>
                    <Box style={{ width: '20%' }}>
                        <Item>
                            <lable style={{ fontFamily: 'Times New Roman', fontWeight: 'bold', fontSize: '10px', color: 'red' }}>Allocated Purpose</lable>

                            <TableContainer sx={{ maxHeight: 300 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell className='tblrowcss' style={{ width: '10px', textAlign: 'center' }}>Sl</StyledTableCell>
                                            <StyledTableCell className='tblrowcss' style={{ textAlign: 'center' }}>Description</StyledTableCell>
                                            <StyledTableCell className='tblrowcss' style={{ width: '40px', textAlign: 'center' }}>Amount</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {AllocationDetails3.map((trns) => {
                                            const isItemSelected = isReqItemSelected(trns.reqAmount);
                                            return (
                                                <TableRow selected={isItemSelected} hover key={trns.reqPurpose} onClick={() => verifypurpose(trns)}>
                                                    <StyledTableCell className='tblcellcss' style={{ color: 'darkblue', textAlign: 'center' }}>{trns.serialNumber}</StyledTableCell>
                                                    <StyledTableCell className='tblcellcss' style={{ color: 'darkblue', textAlign: 'center' }}>{trns.reqPurpose}</StyledTableCell>
                                                    <StyledTableCell className='tblcellcss' style={{ color: 'darkblue', textAlign: 'center' }}>{trns.reqAmount}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Box>
                    <Box style={{ width: '11.5%' }}>
                        <Item2>
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '10px', fontWeight: 'bold', color: 'red', marginRight: '10px' }}>Allocated Job</lable>
                            {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>
                                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px' }} /> </ToggleButton> */}
                            <TableContainer sx={{ maxHeight: 300 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell className='tblrowcss' style={{ textAlign: 'center' }}>`{FundStsName()}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow >
                                            <StyledTableCell className='tblrowcss' style={{ textAlign: 'center' }}>{fundSrch2()}</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {FilteredDetails2.map((trns) => {
                                            const isItemSelected = isReqjobSelected(trns.consignmentNumber);
                                            return (
                                                <TableRow hover selected={isItemSelected} key={trns.consignmentNumber} onClick={() => getpurpose(trns)}>
                                                    <StyledTableCell className='tblcellcss' style={{ color: 'darkblue', textAlign: 'center' }}>{trns.consignmentNumber}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item2>
                    </Box>
                </Grid2>
                <center hidden={designHidden}><div className='mt-2 mb-1 form-inline'>
                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" color="primary" className='mt-1' disabled={verifyDis} onClick={verifyBtn}>{verifyProcs ? 'processing...' : 'ALLOCATE'}</Button>{' '}
                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="primary" disabled={updateDis} onClick={updateBtn}>{updateProcs ? 'processing...' : 'UPDATE'}</Button>{' '}
                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="primary" disabled={NonverifyDis} onClick={NonverifyBtn}>{nonverifyProcs ? 'processing...' : 'NON ALLOCATE'}</Button>{' '}
                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="primary" disabled={DownldRqstDis} onClick={saveimage}>{dwnldRqstCopyProcs ? 'processing...' : 'DOWNLOAD REQUEST COPY'}</Button>{' '}
                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="primary" onClick={RefreshBtn}>{refreshProcs ? 'processing...' : 'REFRESH'}</Button>
                </div></center>
                <Item hidden={tablehidden}>
                    <TableContainer sx={{ maxHeight: 215 }} className='scrollbarPrime'>
                        <Table className='table table-bordered'>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Sl</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Description</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>RequestAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }} >Request_Date</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>RequestRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>RequestBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stLevelAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stLevelDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stLevelRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stApprovedBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2ndLevelAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2ndLevelDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2ndLevelRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2nd_ApprovedBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedBY</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ReleaseAmmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ReleaseDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ReleaseRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Release_BY</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedAmmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedBY</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {AllocationDetails5.map((trns) => (
                                    <TableRow hover key={trns.reqPurpose}>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.serialNumber}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.reqPurpose}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.reqAmount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }} >{trns.reqDate}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.reqRemarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.reqByName}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.approvalAmunt}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.approvalDate}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.appRemarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.approvalByName}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.firstLevelAmount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.firstLevelDate}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.firstRemarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.firstLevelVeryBy}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.secondLevelAmount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.secondLevelDate}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.secondRemarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.secondLevelVeryBy}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocatedAmount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocatedDate}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocatedRemarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocatedByName}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.releaseAmount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.release_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.releaseRemarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.releaseByName}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audited_by}</StyledTableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Item>
            </div>
        </div>
    )
}
export default FundAllocation